import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useState } from "react";
import { useAuthUserQuery, useUpdateRecommendArticleMutation } from "@/hooks";
/**
 * useViewingArticle.
 * 会員登録完了後の挙動を設定する
 */

export function useViewingArticle() {
  var _useState = useState(false),
      sending = _useState[0],
      setSending = _useState[1];

  var _useAuthUserQuery = useAuthUserQuery({
    fetchPolicy: "cache-only"
  }),
      data = _useAuthUserQuery.data;

  var user = data === null || data === void 0 ? void 0 : data.user;

  var _useUpdateRecommendAr = useUpdateRecommendArticleMutation(),
      _useUpdateRecommendAr2 = _slicedToArray(_useUpdateRecommendAr, 1),
      updateRecommendArticle = _useUpdateRecommendAr2[0];

  var setViewingArticle = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var type,
          id,
          force,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              type = _ref.type, id = _ref.id;
              force = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;

              if (!user) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", false);

            case 4:
              if (!sending || force) {
                setSending(true);
                updateRecommendArticle({
                  variables: {
                    type: type,
                    id: id
                  }
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [user, sending]);
  return {
    setViewingArticle: setViewingArticle
  };
}